import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import locales from "../../../_constants/locales";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../styles/TicketConfirmationPage.css";
import RequestSection from "./RequestSection";
import PersonalInformationSection from "./PersonalInformationSection";
import AddressSection from "./AddressSection";
import ConfirmationSection from "./ConfirmationSection";
import StyledButton from "../../../components/StyledButton.jsx";
import NoticeSection from "./NoticeSection";

class Ticket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReturnAddressAccordionOpen: false,
            ticketOriginal: null,
            ticketUpdated: null,
            isAddressSameChecked: false,
            isConfirmCheckboxChecked: false,
            isUpdateSnackbarOpen: false,
            issue: null
        };
    }

    componentWillMount() {
        this.setState({
            ticketOriginal: this.props.ticket,
            ticketUpdated: this.props.ticketUpdate
        });

        if (!this.props.countryListLoading && this.props.countryList.length === 0) {
            this.props.getCountryList();
        }
        if (!this.props.referencePlatformListLoading && this.props.referencePlatformList.length === 0) {
            this.props.getReferencePlatformList();
        }
        if (!this.props.requestTypeListLoading && this.props.requestTypeList.length === 0) {
            this.props.getRequestTypeList();
        }
        if (!this.props.returnReasonListLoading && this.props.returnReasonList.length === 0) {
            this.props.getReturnReasonList();
        }
    }

    componentDidMount() {
        if (
            JSON.stringify(this.state.ticketOriginal.replacementAddress) === JSON.stringify(this.state.ticketUpdated.returnAddress) &&
            this.state.isAddressSameChecked === false
        ) {
            this.setState({
                isAddressSameChecked: true
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.ticketUpdating === false &&
            prevProps.ticketUpdating === true &&
            JSON.stringify(this.state.ticketUpdated) !== JSON.stringify(this.props.ticketUpdate)
        ) {
            this.setState({
                ticketUpdated: this.props.ticketUpdate
            });
        }

        if (
            JSON.stringify(this.state.ticketUpdated.replacementAddress) !== JSON.stringify(prevState.ticketUpdated.replacementAddress) &&
            this.state.isAddressSameChecked === true
        ) {
            this.setState({
                ticketUpdated: { ...this.state.ticketUpdated, returnAddress: this.state.ticketUpdated.replacementAddress }
            });
        } else if (
            JSON.stringify(this.state.ticketUpdated.returnAddress) !== JSON.stringify(prevState.ticketUpdated.returnAddress) &&
            JSON.stringify(this.state.ticketUpdated.returnAddress) !== JSON.stringify(this.state.ticketUpdated.replacementAddress) &&
            this.state.isAddressSameChecked === true
        ) {
            this.setState({
                isAddressSameChecked: false
            });
        }

        if (this.props.ticketUpdating === false && prevProps.ticketUpdating === true) {
            this.setState({
                isUpdateSnackbarOpen: true
            });
        }

        if (this.props.ticketUpdating === false && prevProps.ticketUpdating === true && this.props.ticketUpdatingError) {
            this.setState({
                issue: this.props.ticketUpdatingError
            });
        }
    }

    handleChange(event) {
        if (event.target.name === "isAddressSameChecked" && event.target.checked === true) {
            this.setState({
                [event.target.name]: event.target.checked,
                ticketUpdated: { ...this.state.ticketUpdated, returnAddress: this.state.ticketUpdated.replacementAddress }
            });
        } else {
            this.setState({ [event.target.name]: event.target.checked });
        }
    }

    handeAccordionExpansionChange(name) {
        this.setState({ [name]: !this.state[name] });
    }

    scrollIntoView(elementId, blockValue = "start") {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: blockValue });
        }
    }

    handleSubmitClick() {
        this.props.updateTicket(this.props.ticketId, this.state.ticketUpdated);
    }

    handleReplacementAddressChange(e) {
        if (e.target.name === "isAddressSameChecked") {
            this.setState({
                [e.target.name]: e.target.checked,
                ticketUpdated: { ...this.state.ticketUpdated, returnAddress: this.state.ticketUpdated.replacementAddress }
            });
        } else {
            this.setState({
                ticketUpdated: {
                    ...this.state.ticketUpdated,
                    replacementAddress: { ...this.state.ticketUpdated.replacementAddress, [e.target.name]: e.target.value },
                    returnAddress: { ...this.state.ticketUpdated.returnAddress, [e.target.name]: e.target.value }
                }
            });
        }
    }

    handleReturnAddressChange(e) {
        this.setState({
            ticketUpdated: {
                ...this.state.ticketUpdated,
                returnAddress: { ...this.state.ticketUpdated.returnAddress, [e.target.name]: e.target.value }
            }
        });
    }

    handleItemChange(itemId, event) {
        let ticketUpdatedCopy = { ...this.state.ticketUpdated };
        let request = ticketUpdatedCopy.requests.filter(
            request => request.returnItems.some(item => item.id === itemId) || request.replacementItems.some(item => item.id === itemId)
        )[0];

        let item = request.returnItems.filter(item => item.id === itemId)[0];
        if (!item) {
            item = request.replacementItems.filter(item => item.id === itemId)[0];
        }

        if (item) {
            item[event.target.name] = event.target.value;

            if (event.target.name === "returnReason") {
                item.returnReasonDescription = null;
            }

            this.setState({
                ticketUpdated: ticketUpdatedCopy
            });
        }
    }

    isSubmitButtonEnabled() {
        return this.state.isConfirmCheckboxChecked === true && !this.props.ticketUpdating;
    }

    handleUpdateSnackbarClose() {
        this.setState({
            isUpdateSnackbarOpen: false
        });
    }

    getIssueLabel() {
        if (this.state.issue) {
            if (locales[this.props.language.code].TICKET_SEARCH.ISSUE[this.state.issue]) {
                return locales[this.props.language.code].TICKET_SEARCH.ISSUE[this.state.issue];
            } else {
                return locales[this.props.language.code].TICKET_SEARCH.ISSUE.ERROR;
            }
        }

        return "";
    }

    handleBackToTicketSeachClick(e) {
        e.preventDefault();
        this.props.history.push("/tickets/search");
    }

    render() {
        if (
            this.props.countryListLoading ||
            this.props.referencePlatformListLoading ||
            this.props.requestTypeListLoading ||
            this.props.returnReasonListLoading
        ) {
            return (
                <div className="relative flex layout vertical">
                    <div className="loading-box fit layout vertical center-center">
                        <CircularProgress size={40} thickness={6} color="primary" />
                    </div>
                </div>
            );
        }

        return (
            <div className="flex layout vertical center ticket-confirmation-container">
                <section className={`flex layout center ticket-confirmation center-justified`}>
                    <div className="navigation-panel">
                        <a className="action-button" href={`${process.env.PUBLIC_URL}/tickets/search`} onClick={this.handleBackToTicketSeachClick.bind(this)}>
                            {`${locales[this.props.language.code].TICKET_SEARCH.TITLE}`}
                        </a>
                    </div>
                    <div className="ticket-confirmation-header">
                        <h1 className="ticket-confirmation-title">
                            {locales[this.props.language.code].TICKET_CONFIRMATION.TITLE} {this.props.ticket.ticketNumber}
                        </h1>
                        <p>{locales[this.props.language.code].TICKET_CONFIRMATION.SUBTITLE}</p>
                    </div>
                    {/* <NoticeSection countryCode={this.props.ticket.replacementAddress.country.code} /> */}
                    {this.state.ticketUpdated.requests.map((request, i) => {
                        var requestIsCancelled = request.requestLogs && request.requestLogs.some(rl => rl.status.code === "CANCELLED");

                        if (!requestIsCancelled) {
                            return (
                                <RequestSection
                                    key={i}
                                    language={this.props.language}
                                    request={request}
                                    handleChange={this.handleItemChange.bind(this)}
                                    view={"TICKET_CONFIRMATION_PAGE"}
                                />
                            );
                        }
                    })}
                    <PersonalInformationSection language={this.props.language} personalInformation={this.state.ticketUpdated.personalInformation} />
                    <AddressSection
                        address={this.state.ticketUpdated.replacementAddress}
                        language={this.props.language}
                        handleChange={this.handleReplacementAddressChange.bind(this)}
                        isAddressSameCheckboxAvailable={false}
                        isAddressSameCheckboxChecked={this.state.isAddressSameChecked}
                    />
                    {/* disabled for phase 1 */}
                    {/* <AddressAccordionSection
                        expanded={this.state.isReturnAddressAccordionOpen}
                        onChange={this.handeAccordionExpansionChange.bind(this, "isReturnAddressAccordionOpen")}
                        handleChange={this.handleReturnAddressChange.bind(this)}
                        address={this.state.ticketUpdated.returnAddress}
                        language={this.props.language}
                    /> */}
                    <ConfirmationSection
                        language={this.props.language}
                        ticketUpdating={this.props.ticketUpdating}
                        ticketUpdatingError={this.props.ticketUpdatingError}
                        handleChange={this.handleChange.bind(this)}
                        handleSubmitClick={this.handleSubmitClick.bind(this)}
                        submitButtonDisabled={!this.isSubmitButtonEnabled()}
                    />
                    <div className="footer layout vertical">
                        {/* {this.state.issue && (
                            <div className="issue-box flex layout horizontal">
                                <div className="flex layout horizontal center">
                                    <p style={{ color: "#bf0000", fintWeight: 500 }}>{this.getIssueLabel()}</p>
                                </div>
                            </div>
                        )} */}
                    </div>
                </section>
            </div>
        );
    }
}

export default withRouter(Ticket);
